import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { haveValue } from "../helper/common";
import { useCookies } from "react-cookie";

import { persistSkorSdkFromUrl } from "../helper/skorSdk";
const RedirectPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);

  useEffect(() => {
    // Get the query parameters from the URL
    const queryParams = new URLSearchParams(location.search);
    // Extract the token from the query parameters
    const token = queryParams.get("token");
    const publicKey = queryParams.get("publicKey");
    const usertype = queryParams.get("usertype");
    const is_verified = queryParams.get("is_verified");
    const app_type = queryParams.get("app_type");
    // Helper: decode user id from JWT when saveduserid is not explicitly passed (SDK iframe)
    const decodeIdFromToken = (t) => {
      try {
        if (!t || !t.includes(".")) return null;
        const payload = t.split(".")[1];
        const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const padded = b64.padEnd(Math.ceil(b64.length / 4) * 4, "=");
        const json = JSON.parse(atob(padded));
        return json.id || json._id || json.userId || null;
      } catch {
        return null;
      }
    };
    const saveduserid =
      queryParams.get("saveduserid") || decodeIdFromToken(token) || "";
    const external_customer_id =
      queryParams.get("external_customer_id") || saveduserid || "";
    const goToPage = queryParams.get("go_to_page");
    const propertyId =
      queryParams.get("propertyId") ||
      queryParams.get("property_id") ||
      queryParams.get("property");
    const applicationId =
      queryParams.get("applicationId") ||
      queryParams.get("application_id") ||
      queryParams.get("application");
    // const guarantorFor = queryParams.get("guarantorFor");

    const safeSet = (key, val) => {
      if (val && val !== "null" && val !== "undefined")
        localStorage.setItem(key, val);
      else localStorage.removeItem(key);
    };
    safeSet("token", token);
    safeSet("usertype", usertype);
    safeSet("is_verified", is_verified);
    safeSet("saveduserid", saveduserid);
    safeSet("external_customer_id", external_customer_id);
    // Use helper so skor-sdk is persisted consistently (handles stale "null" etc.)
    if (app_type && app_type !== "null" && app_type !== "undefined") {
      localStorage.setItem("app_type", app_type);
    }
    if (haveValue(publicKey)) {
      localStorage.setItem("publicKey", publicKey);
    }
    // Also sync from URL via helper (covers appType camelCase)
    persistSkorSdkFromUrl(location.search);
    localStorage.setItem("loggedin_by", "admin");

    if (usertype === "tenant") {
      // if (haveValue(guarantorFor)) {
      //   localStorage.setItem("guarantorFor", guarantorFor);
      // }
      if (haveValue(goToPage)) {
        navigate(goToPage);
      } else {
        navigate("/tenant");
      }
    } else {
      // landlord – prefer explicit goToPage, then applicationId-derived report, else home
      // For workspace-aware routes, prefix with workspaceId if available
      const workspaceId =
        queryParams.get("workspaceId") ||
        queryParams.get("wid") ||
        queryParams.get("workspace_id") ||
        localStorage.getItem("current_workspace") ||
        "";
      const prefix = haveValue(workspaceId) ? `/${workspaceId}` : "";
      if (haveValue(goToPage)) {
        // goToPage already contains workspace prefix if SDK sent it, else add prefix
        const target = goToPage.startsWith("/")
          ? goToPage
          : `${prefix}${goToPage.startsWith("/") ? "" : "/"}${goToPage}`;
        navigate(target);
      } else if (haveValue(applicationId)) {
        const params = new URLSearchParams();
        if (propertyId) params.set("propertyId", propertyId);
        params.set("applicationId", applicationId);
        if (haveValue(app_type)) params.set("app_type", app_type);
        navigate(`${prefix}/linked-report-overview?${params.toString()}`);
      } else {
        navigate("/home");
      }
    }
  }, [location]);
  return "RedirectPage";
};

export default RedirectPage;
